import _toString from "lodash/toString"

export const getConfigurationsDataPreviews = (state, configurationId, type) =>
  state.dataPreviews.getIn([_toString(configurationId), type])
